
export class Intervention {
    AppendixId: number;
    Name: string;
    OrderBy: number;

    constructor(AppendixId: number, name: string, ordering: number) { this.AppendixId = AppendixId; this.Name = name; this.OrderBy = ordering; }
}


export class InterventionEvent {
    StudyId: number;
    SiteNumber: number;
    AppendixId: number;
    //Consented: number;
    StartedIntervention: number;
    InterventionStatusId: number;
    StudyStatusId: number; 
    DnsInterventionReasonId: number;
    DisconInterventionReasonId: number;
    DncInterventionReasonId: number;
    DncStudyReasonId: number;
    SubjectId: string;

    //initialize(): void {

    //}
}